import _toArray from "@babel/runtime/helpers/toArray";
var _getOptionalValue = function getOptionalValue(target, fields) {
  var _fields = _toArray(fields),
    currentField = _fields[0],
    remainingFields = _fields.slice(1);
  if (target) {
    if (remainingFields.length === 0) {
      return target[currentField];
    }
    return _getOptionalValue(target[currentField], remainingFields);
  }
  return undefined;
};
export default (function (target, field) {
  return _getOptionalValue(target, field.split('.'));
});